import { Component, OnDestroy, OnInit, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AuthService } from 'src/app/data/service/auth.service';
import { environment } from 'src/environments/environment';
import { SpartaxCQStateService, SpartaxCQState } from 'src/app/data/service/spartax-cq-state.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-spartax-header',
  templateUrl: './spartax-header.component.html',
  styleUrls: ['./spartax-header.component.scss'],
})
export class SpartaxHeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  public spartaxProd = environment.spartaxProd;
  public anonymous = true;
  public isCQActive = false;
  public cqInfo: string | undefined;
  
  private cqStateSubscription: Subscription;
  private mutationObserver: MutationObserver | null = null;

  constructor(
    private navCtrl: NavController,
    private authService: AuthService,
    private spartaxCQStateService: SpartaxCQStateService,
    private elementRef: ElementRef
  ) {
    if (this.authService.currentUserValue) {
      this.anonymous = false;
    }
  }

  ngOnInit() {
    this.cqStateSubscription = this.spartaxCQStateService.cqState$.subscribe((state: SpartaxCQState) => {
      this.isCQActive = state.isActive;
      this.cqInfo = state.info;
    });
  }

  ngOnDestroy() {
    if (this.cqStateSubscription) {
      this.cqStateSubscription.unsubscribe();
    }
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  }

  isMobile() {
    return window.innerWidth <= 770;
  }

  async logout() {
    this.navCtrl.navigateRoot('login');
    this.authService.logout();
  }

  ngAfterViewInit() {
    this.updateScrollMargin();
    this.observeHeaderChanges();
  }

  @HostListener('window:resize')
  onResize() {
    this.updateScrollMargin();
  }

  private updateScrollMargin() {
    setTimeout(() => {
      const headerElement = this.elementRef.nativeElement.querySelector('.beeex4-header-container');
      if (headerElement) {
        const height = headerElement.offsetHeight + 20;
        document.documentElement.style.setProperty('--header-scroll-margin', `${height}px`);
      }
    }, 50);
  }

  private observeHeaderChanges() {
    const headerElement = this.elementRef.nativeElement.querySelector('.beeex4-header-container');
    if (headerElement) {
      this.mutationObserver = new MutationObserver(() => {
        this.updateScrollMargin();
      });
      
      this.mutationObserver.observe(headerElement, {
        childList: true,
        subtree: true,
        attributes: false
      });
    }
  }
}
